import React from 'react';
import { $Divider } from './styles';
export const Divider = (props) => React.createElement($Divider, { ...props });
